// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2OSaT","content":"LayoutSettings_content__2jCBw"};